// src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// سنحتاج Authentication لاحقاً لتأمين الداشبورد
import { getAuth } from "firebase/auth";

// استبدل البيانات التالية ببيانات مشروعك من Firebase Console
// Project Settings -> General -> Your apps -> SDK setup and configuration
const firebaseConfig = {
  apiKey: "AIzaSyD0u3v2Zedv_TOTvXDagjc5pL9OkbOIaXM",
  authDomain: "elwakeel-7ffea.firebaseapp.com",
  projectId: "elwakeel-7ffea",
  storageBucket: "elwakeel-7ffea.firebasestorage.app",
  messagingSenderId: "423061613204",
  appId: "1:423061613204:web:eb5e488067a5c53ca7a281",
  measurementId: "G-7WL8T105WX",
};

// تهيئة التطبيق
const app = initializeApp(firebaseConfig);

// تصدير الأدوات لاستخدامها في باقي الملفات
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
